// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"style_linkColor__nnn7x","phoneNumberDirection":"style_phoneNumberDirection__R8QEE"};